import { render, staticRenderFns } from "./RegisterPageContent.vue?vue&type=template&id=c992674c&scoped=true"
import script from "./RegisterPageContent.vue?vue&type=script&lang=js"
export * from "./RegisterPageContent.vue?vue&type=script&lang=js"
import style0 from "./RegisterPageContent.vue?vue&type=style&index=0&id=c992674c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c992674c",
  null
  
)

export default component.exports